"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperStatusDate = exports.WrapperDate = exports.Bullet = exports.BubbleRight = exports.BubbleLeft = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _atoms = require("../../../../atoms");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var WrapperStatusDate = exports.WrapperStatusDate = _styledComponents["default"].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"])));
var BubbleLeft = exports.BubbleLeft = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  width: 85%;\n"])));
var WrapperDate = exports.WrapperDate = (0, _styledComponents["default"])(_atoms.Text)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  text-align: left;\n  font-size: var(--font-size-xxxs);\n  color: var(--color-neutral-120);\n  text-wrap: nowrap;\n"])));
var Bullet = exports.Bullet = _styledComponents["default"].span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 2px;\n  height: 2px;\n  background-color: var(--color-neutral-120);\n  margin: 0 var(--spacing-0-5);\n"])));
var BubbleRight = exports.BubbleRight = _styledComponents["default"].span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n"])));